const requestInitDefaults: RequestInit = {
  credentials: 'include',
}

const messageFromErrorBody = (body: unknown): string | null => {
  if (!body || typeof body !== 'object') return null
  const payload = body as { message?: unknown; error?: unknown }
  if (typeof payload.message === 'string' && payload.message) {
    return payload.message
  }
  if (typeof payload.error === 'string' && payload.error) {
    return payload.error
  }
  return null
}

export class FetchError extends Error {
  constructor(msg: string, res: Response, url: string, errors: unknown) {
    super(msg)
    this.name = 'FetchError'
    this.url = url
    this.res = res
    this.errors = errors
  }
  res: Response
  errors: unknown
  url: string
}

export default async function fetch(
  url: string,
  requestInit = {} as RequestInit,
) {
  const res = await window.fetch(url, {
    ...requestInitDefaults,
    ...requestInit,
  })
  if (!res.ok) {
    if (res.status !== 401) {
      const errors = res.headers
        .get('content-type')
        ?.includes('application/json')
        ? await res.json()
        : null
      throw new FetchError(
        messageFromErrorBody(errors) ?? `Request failed (${res.status})`,
        res,
        url,
        errors,
      )
    }
  }
  if (res.status !== 204) {
    return res.json()
  } else {
    return
  }
}
